export const getCookieCustom = (cName) => {
  const name = cName + '=';
  const cDecoded = decodeURIComponent(document.cookie); //to be careful
  const cArr = cDecoded.split('; ');
  let res;
  cArr.forEach((val) => {
    if (val.indexOf(name) === 0) res = val.substring(name.length);
  });

  return res;
};

const buildCookieAttributes = ({
  maxAge = cookieValidity,
  path = "/",
  domain,
  expires,
  sameSite,
  secure,
} = {}) =>
  [
    maxAge !== undefined && maxAge !== null && `max-age=${maxAge}`,
    `path=${path}`,
    domain && domain !== "localhost" && `domain=${domain}`,
    expires && `expires=${expires.toUTCString()}`,
    sameSite && `SameSite=${sameSite}`,
    secure && "Secure",
  ]
    .filter(Boolean)
    .join(";");

export const setCookieCustom = (key, value, options = {}) => {
  document.cookie = `${key}=${JSON.stringify(value)};${buildCookieAttributes(
    options,
  )}`;
};

export const removeCookieCustom = (name, options = {}) => {
  document.cookie = `${name}=;${buildCookieAttributes({
    ...options,
    maxAge: 0,
    expires: new Date(0),
  })}`;
};

export const cookieValidity = 60 * 60 * 24 * 30;
